export default "__VITE_ASSET__BORS_DHy__"